import { api } from "../../../api/Middleware";
import { API_URL, MARKETPLACE_API_URL } from "../../../api/Urls";

// =============================
// MARKETPLACE SLUG SERVICES
// =============================

class MarketplaceSlugServices {
  // Função para gerar slug a partir do texto
  static generateSlug(text) {
    if (!text) return '';
    
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove caracteres especiais
      .replace(/\s+/g, '-') // Substitui espaços por hífens
      .replace(/-+/g, '-') // Remove múltiplos hífens
      .replace(/^-|-$/g, ''); // Remove hífens no início/fim
  }

  // Verificar disponibilidade do slug
  static async checkSlugAvailability(slug) {
    try {
      const response = await api.get(
        `${MARKETPLACE_API_URL}seller-profiles/check_slug_availability/`,
        {
          params: {
            slug: slug,
          },
        }
      );

      const data = response.data?.data || response.data;
      
      return {
        success: response.data?.success || true,
        slug: data?.slug || slug,
        normalized_slug: data?.normalized_slug || slug,
        available: data?.available || false,
        exists: data?.exists || false,
        suggestions: data?.suggestions || []
      };
    } catch (error) {
      console.error('Erro ao verificar disponibilidade do slug:', error);
      
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.detail || 'Erro ao verificar disponibilidade',
        available: false,
        exists: false,
        suggestions: []
      };
    }
  }

  // Função para verificar disponibilidade sem debounce (para botão)
  static async checkDisplayNameAvailability(displayName, type = 'profile') {
    if (!displayName || displayName.trim().length < 2) {
      return {
        success: false,
        error: 'Nome deve ter pelo menos 2 caracteres',
        available: false,
        suggestions: []
      };
    }
    
    const slug = this.generateSlug(displayName);
    return await this.checkSlugAvailability(slug, type);
  }

  // Validar formato do slug
  static validateSlugFormat(slug) {
    const errors = [];
    
    if (!slug) {
      errors.push('Slug é obrigatório');
      return { isValid: false, errors };
    }
    
    if (slug.length < 3) {
      errors.push('Slug deve ter pelo menos 3 caracteres');
    }
    
    if (slug.length > 50) {
      errors.push('Slug deve ter no máximo 50 caracteres');
    }
    
    if (!/^[a-z0-9-]+$/.test(slug)) {
      errors.push('Slug deve conter apenas letras minúsculas, números e hífens');
    }
    
    if (slug.startsWith('-') || slug.endsWith('-')) {
      errors.push('Slug não pode começar ou terminar com hífen');
    }
    
    if (slug.includes('--')) {
      errors.push('Slug não pode conter hífens consecutivos');
    }

    // Palavras reservadas
    const reserved = ['api', 'www', 'admin', 'app', 'marketplace', 'seller', 'profile', 'store'];
    if (reserved.includes(slug)) {
      errors.push('Este slug é uma palavra reservada');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }
}

export default MarketplaceSlugServices;